import { useState, useEffect } from "react";
import { EmployeeRecord, UpdateEmployeeRecordContract } from "winslow-core";
import { apiGetEmployeeRecord, apiUpdateEmployeeRecord } from "../../../services/EmployeeRecordService";
import toast from "react-hot-toast";
import { toastFail } from "../../../config";
import "./DCEmployeeRecord.css";
import { EmployeeRecordAddress } from "../app-employee-records/EmployeeRecordAddress";
import { AppChanges } from "../app-changes/AppChanges";
import { EmployeeRecordDaysOfWork } from "../app-employee-records/EmployeeRecordDaysOfWeek";
import { AppEmployeeRecordNew } from "../app-employee-records/AppEmployeeRecordNew";
import { erGetCPValue } from "../app-employee-records/employeeRecordUtils";

type DCEmployeeRecordProps = {
    id: string;
    viewOnly?: boolean;
    properties: string[];
    onCancel: () => void;
    onSubmit: () => void;
}

export const DCEmployeeRecord = ({
    id,
    viewOnly = false, 
    properties,
    onCancel,
    onSubmit
} : DCEmployeeRecordProps) => {

    const [newEmployeeRecord, setNewEmployeeRecord] = useState<EmployeeRecord | null>(null);
    const [hasChanges, setHasChanges] = useState<boolean>(false);

    useEffect(() => {
        if (id) {
            (async () => {
                const er = await apiGetEmployeeRecord(id);

                if (!er) {
                    toast.error("Failed to load employee record.", toastFail);
                    return;
                }

                setNewEmployeeRecord(er);
            })();
        }
    }, [id]);

    const handlePropertyChange = (label: string, data: any) => {
        if (!newEmployeeRecord) {
            return;
        }

        setNewEmployeeRecord({
            ...newEmployeeRecord,
            [label]: data
        });

        setHasChanges(true);
    }

    const handleSubmit = async () => {
        if (!newEmployeeRecord) {
            return;
        }

        const payload: Partial<EmployeeRecord> = {
            ...newEmployeeRecord,
            id: newEmployeeRecord.id,
        };
        
        // properties.forEach((property: string) => {
        //     payload[property as keyof EmployeeRecord] = newEmployeeRecord[property as keyof EmployeeRecord]
        // })

        const updatedEmployeeRecord = await apiUpdateEmployeeRecord(payload);

        if (!updatedEmployeeRecord) {
            toast.error("Failed to update employee record.", toastFail);
            return;
        }

        onSubmit();
    }

    const handleCancel = () => {
        onCancel();
    }

    console.log("[DCEmployeeRecord] newEmployeeRecord: ", newEmployeeRecord);
    console.log("[DCEmployeeRecord] properties: ", properties);

    return (
        <>
            <div className="dc-employee-record">
                {properties.map((property) => {
                    
                    switch (property) {
                        case "address":
                            return (
                                <div 
                                    key={property}
                                    className="dc-employee-record-property"
                                >
                                    <EmployeeRecordAddress
                                        address={erGetCPValue(newEmployeeRecord, "system-address") || ""}
                                        onChange={handlePropertyChange}
                                    />
                                </div>
                            );
                        case "daysOfWork":
                            return (
                                <div 
                                    key={property}
                                    className="dc-employee-record-property"
                                >
                                    <EmployeeRecordDaysOfWork
                                        daysOfWork={erGetCPValue(newEmployeeRecord, "system-daysOfWork") || ""}
                                        onChange={handlePropertyChange}
                                    />
                                </div>
                            );
                        case "":
                        default:
                            // if we don't have a specific component, render the whole one
                            return (
                                <>
                                    Missing ui property: {property}
                                </>
                            );
                        }
                    })
                }
                {properties.length === 0 &&
                    <AppEmployeeRecordNew
                        id={id}
                        genericProps={undefined}
                    />
                }
            </div>

            {hasChanges &&
                <AppChanges 
                    submitText={"Update"}
                    onSubmit={handleSubmit}
                    onCancel={handleCancel}
                />
            }
        </>
    )
}